import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

import { NotificationComponent } from './organisms/notification/notification.component';
import { SimpleModalComponent } from './organisms/simple-modal/simple-modal.component';
import { LoadingComponent } from './organisms/loading/loading.component';
import { HeaderComponent } from './organisms/header/header.component';
import { FormatNumberPipe } from '../core/pipes/format-number.pipe';
import { ModalComponent } from './organisms/modal/modal.component';
import { ErrorComponent } from './organisms/error/error.component';
import { FormatMoneyPipe } from '../core/pipes/format-money.pipe';
import { ButtonComponent } from './atoms/button/button.component';
import { FormatCnpjPipe } from '../core/pipes/format-cnpj.pipe';
import { FormatCepPipe } from '../core/pipes/format-cep.pipe';
import { FormatPhonePipe } from '../core/pipes/format-phone.pipe';
import { ToastNotificationComponent } from './components/toast-notification/toast-notification.component';
import { PermissionDirective } from './directives/permission.directive';
import { FieldPermissionDirective } from './directives/FieldPermission.directive';
import { FormFieldPermissionsDirective } from './directives/FormFieldPermissions.directive';
import { ViewOnlyFieldPermissionDirective } from './directives/ViewOnlyFieldPermission.directive';
import { CreateUserModalComponent } from './components/create-user-modal/create-user-modal.component';

@NgModule({
  declarations: [
    HeaderComponent,
    ModalComponent,
    SimpleModalComponent,
    NotificationComponent,
    FormatCnpjPipe,
    FormatMoneyPipe,
    FormatNumberPipe,
    FormatCepPipe,
    FormatPhonePipe,
    LoadingComponent,
    ErrorComponent,
    ToastNotificationComponent,
    PermissionDirective,
    FieldPermissionDirective,
    FormFieldPermissionsDirective,
    ViewOnlyFieldPermissionDirective,
    CreateUserModalComponent,
  ],
  providers: [
  ],
  exports: [
    CommonModule,
    HeaderComponent,
    ModalComponent,
    SimpleModalComponent,
    NotificationComponent,
    FormatCnpjPipe,
    FormatMoneyPipe,
    FormatCepPipe,
    FormatNumberPipe,
    FormatPhonePipe,
    LoadingComponent,
    ErrorComponent,
    ToastNotificationComponent,
    PermissionDirective,
    FieldPermissionDirective,
    FormFieldPermissionsDirective,
    ViewOnlyFieldPermissionDirective,
    ButtonComponent,
    CreateUserModalComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    ButtonComponent,
    ReactiveFormsModule,
    FormsModule
  ]
})
export class SharedModule { }
